@if (templateRef) {
<ng-container [ngTemplateOutlet]="templateRef" />
} @else {
<span>{{message()}}</span>
}
